module.exports = ".wContainer {\n  max-width: 1180px;\n  margin: 0 auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main